import { useContext } from 'react';
import { TenantContext } from './tenant-context';
export default function useTenantContext() {
    return useContext(TenantContext);
}
